// extracted by mini-css-extract-plugin
module.exports = {"searchLoading":"search-loading_searchLoading__cf1NQ","searchLoadingText":"search-loading_searchLoadingText__Eeuo7"};